let date = new Date();
date.setDate(1);
export default {
    dates: [date.toStringRu(), new Date().toStringRu()],
    AccountId: '',
    SubAccountId: '',
    ContragentId: '',
    ContragentName: '',
    CurrencyId: '',
    PaymentAccountId: '',
    WithTurns: false,
    WithDocumens: false,
}